import { atom } from 'recoil';

export interface ICaptureListState {
  slotId: number;
  imagePreview: string;
  imageFile: File;
}

export const captureListState = atom<ICaptureListState[]>({
  key: 'capturelist',
  default: [],
});
